// API Configuration
const API_CONFIG = {
  // Base URL for API calls (without /api/v1)
  // Use environment variable for production, fallback to localhost for development
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001',
  
  // API version
  API_VERSION: process.env.REACT_APP_API_VERSION || 'v1',
  
  // Full API base URL
  get API_BASE() {
    // Handle relative paths (production) vs full URLs (development)
    if (this.BASE_URL.startsWith('/')) {
      // Relative path - use as is
      return this.BASE_URL;
    } else {
      // Full URL - append /api/version
      return `${this.BASE_URL}/api/${this.API_VERSION}`;
    }
  },
  
  // Specific endpoints
  get ENDPOINTS() {
    return {
      PROJECTS: `${this.API_BASE}/projects`,
      PROJECTS_STATS: `${this.API_BASE}/projects/stats/summary`,
      RISKS: `${this.API_BASE}/risks`,
      AUTH: `${this.API_BASE}/auth`,
      ASSETS: `${this.API_BASE}/assets`,
      CONTRACTS: `${this.API_BASE}/contracts`,
      CUSTOMERS: `${this.API_BASE}/customers`,
      USERS: `${this.API_BASE}/users`,
      ROLES: `${this.API_BASE}/roles`,
      SETTINGS: `${this.API_BASE}/settings`,
      DASHBOARD: `${this.API_BASE}/dashboard`,
      AUTO_INCREMENT: `${this.API_BASE}/auto-increment`,
      TASKS: `${this.API_BASE}/tasks`,
      TASKS_STATS: `${this.API_BASE}/tasks/stats/overview`,
      TIME_ENTRIES: `${this.API_BASE}/time-entries`,
      TIME_ENTRIES_STATS: `${this.API_BASE}/time-entries/stats`,
      TEAM_MEMBERS: `${this.API_BASE}/team-members`,
      TIMESHEETS: `${this.API_BASE}/timesheets`,
      PROJECT_INVOICES: `${this.API_BASE}/project-invoices`,
      VENDORS: `${this.API_BASE}/vendors`, 
      SOURCING_RFPS: `${this.API_BASE}/sourcing/rfps`,
      SOURCING_AWARDS: `${this.API_BASE}/sourcing/evaluation-award`,
      DOA: `${this.API_BASE}/doa`,
    };
  },
  
  // Request headers
  get HEADERS() {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }
};
console.log('Resolved API BASE:', API_CONFIG.API_BASE);
export default API_CONFIG;
